import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { CustomInputEditor } from '../custom-inputEditor';
import { RestApiService } from '../rest-api.service';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Formatters, OnEventArgs } from 'angular-slickgrid';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

// import * as CryptoJS from 'crypto-js';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-admin-user',
  templateUrl: './admin-user.component.html',
  styleUrls: ['./admin-user.component.css']
})
export class AdminUserComponent implements OnInit, OnDestroy {

  displayed = true;
  userName: string;
  email: string;
  password: string;
  address: string;
  mobile: string;
  totalData = 0;
  show: boolean;
  selected: number;
  respObject: any;
  data: any;
  clientId: number;

  displayData: any;
  displayData1: any;
  showSearch = true;

  add = false;
  del = false;
  edit = false;
  view = false;

  isError = false;
  errorMessage: string;
  nextOffset: number;
  previousOffset: number;
  collectionSize: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private adminAuth: Subscription;
  private notifier: NotifierService;
  loginName: string;
  private userAuth: Subscription;
  offset: number;
  dataLoaded: boolean;
  usrs: any;
  userId: number;
  isLoading = false;
  searchUser: FormControl = new FormControl();
  userSelected: any;
  isServiceUser: boolean;
  userType: string;

  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;


  cPassword: any;
  confirmpassword: any;
  selectedId: any;
  @ViewChild('content1') private content1;
  private modalReference: NgbModalRef;
  signin: FormGroup = new FormGroup({
    // email: new FormControl('', [Validators.email, Validators.required ]),
    password: new FormControl('', [Validators.required, Validators.min(3)])
  }); s
  hide = true;
  //   get emailInput() { return this.signin.get('email'); }
  get passwordInput() {
    return this.signin.get('password');
  }

  passwords: FormGroup = new FormGroup({
    // email: new FormControl('', [Validators.email, Validators.required ]),
    password: new FormControl('', [Validators.required, Validators.min(3)])
  }); a
  hides = true;
  //   get emailInput() { return this.signin.get('email'); }
  get passwordInput1() {
    return this.signin.get('password');
  }





  constructor(private _rest: RestApiService, private messageService: MessageService,
    private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          if (this.baseFlag) {
            console.log('admin');
            if (!this.edit) {
              this.notifier.notify('error', 'You do not have edit permission');
            } else {
              if (confirm('Are you sure?')) {
                this.editItem(item);
              }
            }
          } else {
            console.log('non admin', this.messageService.edit);
            if (!this.messageService.edit) {
              this.notifier.notify('error', 'You do not have edit permission');
            } else {
              if (confirm('Are you sure?')) {
                this.editItem(item);
              }
            }
          }
          break;
        case 'delete':
          if (this.baseFlag) {
            if (!this.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              if (confirm('Are you sure?')) {
                this.deleteItem(item);
              }
            }
          } else {
            if (!this.messageService.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              if (confirm('Are you sure?')) {
                this.deleteItem(item);
              }
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      // console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  deleteItem(item) {
    this._rest.deleteUserFrmAdmin({ id: item.id, user_id: this.messageService.getUserId(), clientId: this.clientId }).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.messageService.sendAfterDelete(item.id);
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  editItem(item) {
    const data = {
      name: item.name,
      createdBy: this.messageService.getUserId(),
      address: item.address,
      mobile: btoa(this.messageService.xorEncode(item.mobile, this.messageService.SECRET_TOKEN)),
      email: btoa(this.messageService.xorEncode(item.email, this.messageService.SECRET_TOKEN)),
      id: item.id
    };
    this._rest.editUserMst(data).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.notifier.notify('success', 'Updated successfully');
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  ngOnInit() {
    this.dataLoaded = false;
    this.isServiceUser = false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain User',
      openModalButton: 'Add User',
      searchModalButton: 'Search',
      breadcrumb: 'AddUser',
      folderName: 'All Users',
      tabName: 'Users'
    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      {

        id: 'edit',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.editIcon,
        minWidth: 30,
        maxWidth: 30,
        toolTip: 'Change Password',
        onCellClick: (e: Event, args: OnEventArgs) => {
          console.log(args.dataContext);
          this.selectedId = args.dataContext.id;


          this.modalReference = this.modalService.open(this.content1, { size: 'sm' });
          this.modalReference.result.then((result) => {
          }, (reason) => {

          });
        }

      },

      {
        id: 'name', name: 'Name', field: 'name', sortable: true, filterable: true, cssClass: 'highlight', editor: {
          model: CustomInputEditor
        }
      },
      {
        id: 'login_name', name: 'Login ID', field: 'login_name', sortable: true, filterable: true
      },
      {
        id: 'email', name: ' Email ID', field: 'email', sortable: true, filterable: true, cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'mobile', name: ' Contact Number', field: 'mobile', sortable: true, filterable: true, cssClass: 'highlight',
        editor: { model: CustomInputEditor }
      },
      {
        id: 'address', name: 'Address', field: 'address', sortable: true, filterable: true, cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'userType', name: 'User Type', field: 'user_type', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }

    this.searchUser.valueChanges.subscribe(
      psOrName => {
        this.isLoading = true;
        const role_id = 0;
        this._rest.searchAllUser(this.clientId, psOrName, role_id).subscribe((res1) => {
          this.respObject = res1;
          this.isLoading = false;
          if (this.respObject.success) {
            this.usrs = this.respObject.details;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.isLoading = false;
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
      });

  }

  onPageLoad() {
    if (this.baseFlag) {
      this.displayData = {
        pageName: 'Create Platform Admin ',
        openModalButton: 'Add Platform Admin',
        searchModalButton: 'Search',
        breadcrumb: 'AddPlatformAdmin',
        folderName: 'All Platform Admins',
        tabName: 'Platform Admin'
      };
    }
    this.getTableData();
  }


  confirm() {
    if (this.cPassword === this.confirmpassword) {
      // alert('matched');
      const data = {
        clientId: this.clientId,
        id: this.selectedId,
        cPassword: this.cPassword,
        confirmPassword: this.confirmpassword
      };
      console.log('================' + JSON.stringify(data));
      this._rest.changeUserPassword(data).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          this.cPassword = '';
          this.confirmpassword = '';
          this.notifier.notify('success', 'password Changed');
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else {
      this.notifier.notify('error', 'New Password and Confirm Password are not matched');
    }
  }



  openModal(content) {
    if (this.baseFlag) {
      if (!this.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.userName = '';
        this.email = '';
        this.userSelected = '';
        this.modalService.open(content).result.then((result) => {
        }, (reason) => {

        });
      }
    } else {
      if (!this.messageService.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.userName = '';
        this.email = '';
        this.userSelected = '';
        this.modalService.open(content).result.then((result) => {
        }, (reason) => {

        });
      }
    }
  }
  searchModal() {
    if (this.baseFlag) {
      this.userName = '';
      this.userSelected = '';
      this.searchModalReference = this.modalService.open(this.scarch_content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });

    } else {

      this.userName = '';
      this.userSelected = '';
      this.searchModalReference = this.modalService.open(this.scarch_content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });

    }
  }
  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  getUserDetails() {
    for (let i = 0; i < this.usrs.length; i++) {
      if (this.usrs[i].login_name === this.userSelected) {
        this.userId = this.usrs[i].id;
        this.userName = this.usrs[i].name;
      }
    }
  }


  save() {
    const userId = this.messageService.getUserId();
    if (this.isServiceUser === true) {
      this.userType = 'serviceuser';
    }
    this.data = {
      clientId: this.clientId,
      user_id: userId,
      login_name: this.loginName,
      mobile: btoa(this.messageService.xorEncode(this.mobile, this.messageService.SECRET_TOKEN)),
      email: btoa(this.messageService.xorEncode(this.email, this.messageService.SECRET_TOKEN)),
      address: this.address,
      password: this.password,
      // name: btoa(this.messageService.xorEncode(this.userName, this.messageService.SECRET_TOKEN)),
      name: this.userName
    };
    if (!this.messageService.isBlankField(this.data)) {
      this.data['userType'] = this.userType;
      // this.data.password = CryptoJS.AES.encrypt(this.password, this.messageService.SECRET_TOKEN).toString();
      this._rest.insertUser(this.data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          this.isError = false;
          const id = this.respObject.userId;
          this.messageService.setRow({
            id: id,
            name: this.userName,
            mobile: this.mobile,
            email: this.email,
            address: this.address,
            login_name: this.loginName
          });
          if (this.totalData <= this.pageSize * this.page_no) {
            this.offset = id;
            this.nextOffset = 0;
          } else {
            this.nextOffset = this.offset;
          }
          this.userName = '';
          this.mobile = '';
          this.email = '';
          this.address = '';
          this.password = '';
          this.userType = '';
          this.isServiceUser = false;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = err;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (this.baseFlag) {
      if (!this.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        this.getNewTableData({ 'offset': this.nextOffset, 'paginationType': '' });
      }
    } else {
      if (!this.messageService.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        this.getNewTableData({ 'offset': this.nextOffset, 'paginationType': '' });
      }
    }
  }

  getNewTableData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded = false;
    this._rest.getUserByClient(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
    });
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }


  executeResponse(respObject, offset, paginationType) {
    if (respObject.success) {
      this.dataLoaded = true;
      if (offset === 0) {
        this.totalData = respObject.details.totalData[0].count;
        this.totalPage = respObject.details.totalPage;
        if (this.totalPage === 0) {
          this.totalPage = 1;
        }
      }
      if (!this.isEmpty(respObject.details.dataObj)) {
        for (let i = 0; i < respObject.details.dataObj.length; i++) {
          respObject.details.dataObj[i].email = this.messageService.xorEncode(atob(respObject.details.dataObj[i].email),
            this.messageService.SECRET_TOKEN);
          respObject.details.dataObj[i].mobile = this.messageService.xorEncode(atob(respObject.details.dataObj[i].mobile),
            this.messageService.SECRET_TOKEN);
        }
        const data = respObject.details.dataObj;
        this.nextOffset = respObject.details.nextOffset;
        this.offset = respObject.details.nextOffset;
        this.previousOffset = respObject.details.previousOffset;
        this.messageService.setTotalData(this.totalData);
        this.messageService.setGridData(data);
        // ----------------------------------------------
        if (offset !== 0) {
          const totalCount = this.totalData;
          const divRes = totalCount / this.pageSize;
          const remainder = totalCount % this.pageSize;
          if (remainder === 0) {
            this.totalPage = parseInt(String(divRes), 10);
          } else {
            this.totalPage = parseInt(String(divRes), 10) + 1;
          }
        }
        // ------------------------------------------------
        if (paginationType === 'next') {
          this.page_no = this.page_no + 1;
        } else if (paginationType === 'prev') {
          this.page_no = this.page_no - 1;
        } else if (paginationType === '' && this.page_no === 0) {
          this.page_no = this.page_no + 1;
        }
        if (this.totalData <= this.pageSize * this.page_no) {
          this.nextOffset = 0;
        }
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
        this.nextOffset = 0;
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
        this.previousOffset = 0;
      } else if (paginationType === '' && this.page_no === 0) {
        this.page_no = this.page_no + 1;
      }
    } else {
      this.notifier.notify('error', respObject.errorMessage);
    }
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getNewTableData({ 'offset': this.nextOffset, 'paginationType': '' });
  }

  ngOnDestroy(): void {
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }

  search() {
    if (this.usrs.length === 0) {
      this.isError = true;
      this.errorMessage = 'Enter the login id or login name';
    } else {
      this.isError = false;
      this.userId = 0;
      const data1 = [];
      for (let i = 0; i < this.usrs.length; i++) {
        if (this.usrs[i].login_name === this.userSelected) {
          this.usrs[i].email = this.messageService.xorEncode(atob(this.usrs[i].email),
            this.messageService.SECRET_TOKEN);
          this.usrs[i].mobile = this.messageService.xorEncode(atob(this.usrs[i].mobile),
            this.messageService.SECRET_TOKEN);
          this.userId = this.usrs[i];
          data1.push(this.userId);
        }
      }
      this.page_no = 1;
      this.messageService.setTotalData(1);
      this.messageService.setGridData(data1);
      this.searchModalReference.close();

    }
  }
}

